import { render, staticRenderFns } from "./ReservationEditForm.vue?vue&type=template&id=fd63102a"
import script from "./ReservationEditForm.vue?vue&type=script&lang=ts"
export * from "./ReservationEditForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports